(() => {
  if (customElements.get('parallax-element')) {
    return;
  }

  class ParallaxElement extends HTMLElement {
    constructor() {
      super();

      this.updateAnimation = this.updateAnimation.bind(this);
    }

    connectedCallback() {
      this.init();

      const handleIntersection = (entries) => {
        if (entries[0].isIntersecting) {
          this.attachEvents();
        } else {
          this.clearEvents();
        }
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    attachEvents() {
      window.addEventListener('scroll', this.updateAnimation);
    }

    clearEvents() {
      window.removeEventListener('scroll', this.updateAnimation);
    }

    init() {
      this.speed = this.dataset.speed || 1;
      this.parallaxContainer = this.querySelector('[data-parallax-container]');
    }

    updateAnimation() {
      if (!this.parallaxContainer) {
        return;
      }

      let position = -(window.scrollY * this.speed);

      this.parallaxContainer.style.transform = `translateY(${position}px)`;
    }
  }

  customElements.define('parallax-element', ParallaxElement);
})();
